var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.575 19.859H2.426a.87.87 0 0 1-.868-.869V3.217l8.69 7.58-4.996 4.686a.729.729 0 1 0 .998 1.064l5.102-4.786 1.466 1.278a2.56 2.56 0 0 0 1.683.617c.606 0 1.211-.206 1.683-.617l1.467-1.279 5.1 4.787a.727.727 0 0 0 1.032-.034.73.73 0 0 0-.034-1.03l-4.994-4.686 8.689-7.577v15.77a.87.87 0 0 1-.869.869Zm-11.35-7.92c-.385.337-1.063.337-1.449 0L2.542 2.142h23.92L15.225 11.94ZM26.575.683H2.426A2.33 2.33 0 0 0 .1 3.01v15.98a2.33 2.33 0 0 0 2.326 2.327h24.15a2.33 2.33 0 0 0 2.326-2.327V3.01A2.33 2.33 0 0 0 26.575.683Z",
    fill: "currentColor"
  })));
};
export default SvgMail;